import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Rules = styled.div`
  span.rule_heading {
    font-weight: 600;
    color: #141823;
    font-size: 1.8rem;
    margin-bottom: 3.5rem;
  }
  ul {
    display: grid;
    grid-template-columns: 1fr;
    gap: 2rem;
    li {
      display: flex;
      align-items: center;
      .rlIcon {
        width: 3.2rem;
        height: 3.2rem;
        margin-right: 0.8rem;
        display: inline-flex;
      }
      font-size: 1.6rem;
      color: #141823;
    }
  }
`;
